import { Box, Typography, Container } from "@mui/material";

import range from "../../assets/range.png";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function ProductOverview() {
  const productImage =
  range
  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: "#f9f9ff" }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            alignItems: "stretch",
            gap: 5,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* LEFT - IMAGE */}
          <Box
            sx={{
              flex: 1,
              borderRadius: 4,
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              display: "flex",
            }}
          >
            <img
              src={productImage}
              alt="Products Overview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>

          {/* RIGHT - TEXT */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h4"
              fontWeight={800}
              sx={{
                mb: 2,
                color: brandBlue,
                fontSize: { xs: "1.8rem", md: "2.3rem" },
              }}
            >
              Our Product Range
            </Typography>

            <Box
              sx={{
                width: "70px",
                height: "4px",
                background: brandRed,
                borderRadius: 2,
                mb: 3,
              }}
            />

            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                lineHeight: 1.8,
                fontSize: "1.05rem",
              }}
            >
              We manufacture a wide spectrum of industrial solutions designed
              for performance, safety, and durability. Our products include
              precision-engineered generator enclosures, fuel tanks, pressure
              vessels, metal structures, wastewater systems, and
              custom-engineered modules tailored to demanding environments.
              <br />
              <br />
              Each product is engineered using advanced technology, rigorous
              quality control, and the highest manufacturing standards to
              deliver excellence for global industries.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
